import ReactTooltip from 'react-tooltip'
import { styled } from '@xstyled/styled-components'

export const StyledReactTooltip = styled(ReactTooltip)(({ theme }) => ({
  borderRadius: '4px !important',
  fontSize: `${theme.fontSizes.xs} !important`,
  padding: '4px 8px !important'
}))
